/**
 * This CropsContext is modeled similarly to org-context, but is intended to track state changes
 * and dispatch actions for individual crop objects. Use this context for managing crop-specific
 * updates, additions, and removals in the application.
 */

import { createContext, useContext } from "react";
import { CROPS_CONTEXT_ACTION_TYPES } from "./crops-context-reducer";

export const CropsContext = createContext(null)
export const CropsContextDispatch = createContext(null)

export const useCropsContext = () => {
  return useContext(CropsContext)
}

export const useCropsContextDispatch = () => {
  return useContext(CropsContextDispatch)
}

// Dispatch Helpers

export const cropAdded = ({ cropId } = {}) => {
  return {
    type: CROPS_CONTEXT_ACTION_TYPES.CROP_ADDED,
    cropId,
  }
}

export const cropEdited = ({ cropId } = {}) => {
  return {
    type: CROPS_CONTEXT_ACTION_TYPES.CROP_EDITED,
    cropId,
  }
}

export const cropRemoved = ({ cropId } = {}) => {
  return {
    type: CROPS_CONTEXT_ACTION_TYPES.CROP_REMOVED,
    cropId,
  }
}

export const plotAdded = ({ plotId } = {}) => {
  return {
    type: CROPS_CONTEXT_ACTION_TYPES.PLOT_ADDED,
    plotId,
  }
}

export const plotEdited = ({ plotId } = {}) => {
  return {
    type: CROPS_CONTEXT_ACTION_TYPES.PLOT_EDITED,
    plotId,
  }
}

export const plotRemoved = ({ plotId } = {}) => {
  return {
    type: CROPS_CONTEXT_ACTION_TYPES.PLOT_REMOVED,
    plotId,
  }
}

export const taskAdded = ({ taskId } = {}) => {
  return {
    type: CROPS_CONTEXT_ACTION_TYPES.TASK_ADDED,
    taskId,
  }
}

export const taskEdited = ({ taskId, updates } = {}) => {
  return {
    type: CROPS_CONTEXT_ACTION_TYPES.TASK_EDITED,
    taskId,
    updates,
  }
}

export const taskRemoved = ({ taskId } = {}) => {
  return {
    type: CROPS_CONTEXT_ACTION_TYPES.TASK_REMOVED,
    taskId,
  }
}

export const reportAdded = ({ reportId } = {}) => ({
  type: CROPS_CONTEXT_ACTION_TYPES.REPORT_ADDED,
  reportId,
})

export const reportUpdated = ({ reportId } = {}) => ({
  type: CROPS_CONTEXT_ACTION_TYPES.REPORT_UPDATED,
  reportId,
})

export const reportRemoved = ({ reportId } = {}) => ({
  type: CROPS_CONTEXT_ACTION_TYPES.REPORT_REMOVED,
  reportId,
})
